import { render, staticRenderFns } from "./DialogConfirmActionInCourse.vue?vue&type=template&id=08618874&"
import script from "./DialogConfirmActionInCourse.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmActionInCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports